import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading, checkAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);

  useEffect(() => {
    // If user data passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setIsAuthenticated(true);
      return;
    }

    const verifyAuth = async () => {
      if (!loading) {
        if (!user) {
          setIsAuthenticated(false);
          navigate("/login", { state: { from: location.pathname } });
        } else if (requireAdmin && !["admin", "super_admin"].includes(user.role)) {
          // Check if user has admin or super_admin role
          setIsAuthenticated(false);
          navigate("/");
        } else {
          setIsAuthenticated(true);
        }
      }
    };

    verifyAuth();
  }, [user, loading, navigate, location, requireAdmin]);

  if (loading || isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-purple animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return children;
}
